import * as React from 'react';
import Svg, { ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
        <G clipPath="url(#clip0_2328_502309)">
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.3034 4.69647C15.4597 4.85274 15.5475 5.06473 15.5475 5.28572L15.5475 13.5353C15.5475 13.9955 15.1744 14.3686 14.7141 14.3686C14.2539 14.3686 13.8808 13.9955 13.8808 13.5353L13.8808 7.29757L5.87531 15.3031C5.54987 15.6285 5.02225 15.6285 4.6968 15.3031C4.37135 14.9776 4.37135 14.45 4.6968 14.1246L12.7023 6.11906L6.46457 6.11905C6.00435 6.11904 5.63125 5.74594 5.63123 5.28572C5.63122 4.8255 6.00434 4.45238 6.46456 4.45239L14.7142 4.45239C14.9351 4.45237 15.1471 4.5402 15.3034 4.69647Z"
                fill={ds.colorValue.icon.brand}
            />
        </G>
        <Defs>
            <ClipPath id="clip0_2328_502309">
                <Rect width="20" height="20" fill={ds.colorValue.icon.primary} />
            </ClipPath>
        </Defs>
    </Svg>
);

export default SvgComponent;
